import type { EventPopup, EventPopupInput } from '../../services/api/popupApi';

// 「팝업 관리」 입력 칸 값. 일시는 <input type="datetime-local"> 값(관리자 PC 의 시간대 = 한국 시간)으로 다룬다.
export interface PopupFormState {
  title: string;
  text: string;
  buttonText: string;
  linkUrl: string;
  start: string; // YYYY-MM-DDTHH:mm
  end: string;
  active: boolean;
  order: string;
  image: string; // 새로 고른 그림(data URL). 비어 있으면 수정 때 기존 그림을 그대로 둔다
}

export const emptyPopupForm = (): PopupFormState => ({
  title: '', text: '', buttonText: '자세히 보기', linkUrl: '', start: '', end: '', active: true, order: '0', image: '',
});

const pad = (n: number) => String(n).padStart(2, '0');

export const toLocalInput = (iso: string): string => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInput = (value: string): string => {
  if (!value) return '';
  const d = new Date(value);
  return isNaN(d.getTime()) ? '' : d.toISOString();
};

export const formFromPopup = (p: EventPopup): PopupFormState => ({
  title: p.title,
  text: p.text,
  buttonText: p.buttonText,
  linkUrl: p.linkUrl,
  start: toLocalInput(p.startAt),
  end: toLocalInput(p.endAt),
  active: p.active,
  order: String(p.order),
  image: '',
});

export const inputFromForm = (f: PopupFormState): EventPopupInput => ({
  title: f.title.trim(),
  text: f.text.trim(),
  buttonText: f.buttonText.trim(),
  linkUrl: f.linkUrl.trim(),
  startAt: fromLocalInput(f.start),
  endAt: fromLocalInput(f.end),
  active: f.active,
  order: Number(f.order || 0),
  ...(f.image ? { image: f.image } : {}),
});

export type PopupStatus = '게시 중' | '예약' | '종료' | '꺼짐';

// 서버(listActive)와 같은 규칙: 켜져 있고 시작 ≤ 지금 ≤ 끝이면 첫 화면에 뜬다
export const popupStatus = (p: Pick<EventPopup, 'active' | 'startAt' | 'endAt'>, now: Date = new Date()): PopupStatus => {
  if (!p.active) return '꺼짐';
  const t = now.getTime();
  if (t < new Date(p.startAt).getTime()) return '예약';
  if (t > new Date(p.endAt).getTime()) return '종료';
  return '게시 중';
};
